var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('button-group-basic'), _c('button-group-size'), _c('button-group-dropdown-support')], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }